import styled from 'styled-components';
import { Flex, Text } from 'common/common-components.styled';
import { Link } from 'react-router-dom';
import More from 'components/more';

interface WidthProps {
  width: string;
}

export const StyledText = styled(Text)<WidthProps>`
  padding: 20px 10px;
  width: ${({ width }) => width};
`;

export const StyledLink = styled(Link)<WidthProps>`
  padding: 20px 10px;
  width: ${({ width }) => width};
  color: ${({ theme }) => theme.colors.blue};
  text-decoration: underline !important;
`;

export const StyledArrow = styled(Flex)<WidthProps>`
  padding: 20px 10px;
  width: ${({ width }) => width};
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: -2px;
`;

export const StyledEditIcon = styled(Flex)`
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  position: absolute;
  right: 5px;
  top: calc(50% - 12px);
  cursor: pointer;
  display: none;
  box-shadow: 0.5px 3px 10px rgba(0, 0, 0, 0.25);
`;

export const StyledSimpleTableRow = styled(Flex)`
  position: relative;

  &:hover ${StyledEditIcon} {
    display: flex;
  }
`;

export const StyledMore = styled(More)`
  margin-left: 0;
`;
